<ion-content>
  @if (shouldShowSuccessBanner) {
    <div
      style="
        max-width: 400px;
        margin-left: auto;
        margin-right: auto;
        padding: 20px 40px;
        align-items: center;
        font-weight: 500;
        font-size: 1rem;
        border-radius: 14px;
        text-align: center;
        margin-top: 40px;
      "
      class="linear-gradient-subtle-animated"
    >
      <h1>Thanks for subscribing!</h1>
      <p>Welcome aboard 🎉</p>
      <ion-button
        [disabled]="true"
        fill="clear"
        color="dark"
        style="filter: unset"
        >Redirecting you in a moment...</ion-button
      >
    </div>
  } @else {
    <div class="constrained-content">
      <ion-card class="container-card" *ngIf="isLoading">
        <ion-card-header>
          <ion-card-title style="font-size: 2rem"> {{ title }} </ion-card-title>
          <ion-badge
            color="danger"
            *ngIf="trialExpirationBadge"
            style="margin-top: 11px; font-size: 1rem; padding: 10px 12px"
            >{{ trialExpirationBadge }}</ion-badge
          >
        </ion-card-header>
        <div style="text-align: center; padding: 40px">
          <ion-spinner name="crescent"></ion-spinner>
          <p>Checking account status...</p>
        </div>
      </ion-card>
      <div *ngIf="!isLoading">
        <ion-grid>
          <ion-row *ngIf="!isCustomPrice">
            <ion-col size="12">
              <h1
                style="font-size: 2rem; font-weight: 700; margin-bottom: 20px"
              >
                {{ title }}
              </h1>
            </ion-col>
            <ion-col
              size="12"
              size-md="4"
              *ngFor="let plan of plans; let i = index"
            >
              <ion-card
                class="outline-card plan-card"
                [ngClass]="{ selected: i === 1 }"
              >
                <ion-list>
                  <ion-item>
                    <ion-label>
                      <p>Plan</p>
                      <h3 style="font-size: 1.3rem; font-weight: 700">
                        {{ plan.name }}
                      </h3>
                      <ion-badge
                        color="success"
                        *ngIf="
                          isSubscribed &&
                          subscriptionProductId === plan.stripeProductId
                        "
                        >Subscribed</ion-badge
                      >
                      <ion-badge
                        color="success"
                        *ngIf="!isSubscribed && i === 1"
                        >Recommended</ion-badge
                      >
                    </ion-label>
                  </ion-item>
                  <ion-item
                    *ngFor="let feature of plan.features"
                    style="--min-height: 20px"
                  >
                    <ion-icon
                      slot="start"
                      name="checkmark"
                      style="color: green; margin-right: 10px; margin: 0"
                    ></ion-icon>
                    <ion-label text-wrap class="no-margin">
                      {{ feature }}
                    </ion-label>
                  </ion-item>
                  <ion-item
                    *ngFor="let feature of plan.restrictedFeatures"
                    style="--min-height: 20px"
                  >
                    <ion-icon
                      slot="start"
                      name="close"
                      style="color: #a83333; margin-right: 10px; margin: 0"
                    ></ion-icon>
                    <ion-label text-wrap class="no-margin">
                      {{ feature }}
                    </ion-label>
                  </ion-item>
                </ion-list>
                <div class="flexed" [hidden]="isLegacyPlan">
                  <ion-card-header>
                    <ion-card-title>Number of seats</ion-card-title>
                  </ion-card-header>
                  <ion-card-content>
                    <ion-input
                      style="
                        font-size: 1.45rem;
                        margin-bottom: 0;
                        margin-top: 10px;
                      "
                      placeholder="5"
                      min="5"
                      type="number"
                      [(ngModel)]="numberOfSeats"
                      class="input-field"
                    >
                    </ion-input>
                    <ion-card-subtitle
                      >Minimum {{ seatMinimum }} seats</ion-card-subtitle
                    >
                  </ion-card-content>
                </div>
                <ion-card-content>
                  <ion-button
                    *ngIf="!isSubscribed"
                    [disabled]="isLoadingCheckout"
                    class="btn-large"
                    (click)="openCheckout(plan)"
                  >
                    Generate Quote
                  </ion-button>
                  <ion-button
                    *ngIf="isSubscribed"
                    [disabled]="isLoadingCheckout"
                    class="btn-large"
                    (click)="updateSubscription(plan)"
                  >
                    Update Subscription
                  </ion-button>
                </ion-card-content>
              </ion-card>
            </ion-col>
            <ion-col size="12" size-md="4">
              <ion-card class="outline-card plan-card">
                <ion-list>
                  <ion-item>
                    <ion-label>
                      <p>Plan</p>
                      <h3 style="font-size: 1.3rem; font-weight: 700">
                        Custom
                      </h3>
                    </ion-label>
                  </ion-item>
                  <ion-item
                    *ngFor="let feature of enterpriseFeatures"
                    style="--min-height: 20px"
                  >
                    <ion-icon
                      slot="start"
                      name="checkmark"
                      style="color: green; margin-right: 10px; margin: 0"
                    ></ion-icon>
                    <ion-label text-wrap class="no-margin">
                      <span style="font-weight: 500">{{ feature }}</span>
                    </ion-label>
                  </ion-item>
                </ion-list>
                <ion-card-content>
                  <ion-button
                    class="btn-large"
                    slot="end"
                    href="mailto:sales@unthread.io"
                  >
                    Contact us
                  </ion-button>
                </ion-card-content>
              </ion-card>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="isCustomPrice">
            <ion-col size="6">
              <ion-card class="outline-card">
                <ion-card-header>
                  <ion-card-title style="font-size: 2rem">
                    {{ isSubscribed ? "Current Plan" : "Upgrade Your Account" }}
                  </ion-card-title>
                </ion-card-header>
                <ion-list>
                  <ion-item>
                    <ion-label>
                      <p>Plan Type</p>
                      <h3>Unthread Business</h3>
                    </ion-label>
                  </ion-item>
                  <ion-item>
                    <ion-label>
                      <p>Status</p>
                      <h3>
                        <ion-badge color="success" *ngIf="isSubscribed"
                          >Active</ion-badge
                        >
                        <ion-badge color="light" *ngIf="!isSubscribed"
                          >Trial</ion-badge
                        >
                      </h3>
                    </ion-label>
                  </ion-item>
                </ion-list>
              </ion-card>
            </ion-col>
            <ion-col size="6" *ngIf="isSubscribed">
              <div style="padding: 8px">
                <ion-button
                  class="btn-large"
                  [disabled]="isLoadingCheckout"
                  (click)="manageSubscription()"
                >
                  <span [hidden]="isLoadingCheckout"
                    >Manage my subscription</span
                  >
                  <ion-spinner
                    name="crescent"
                    [hidden]="!isLoadingCheckout"
                  ></ion-spinner>
                </ion-button>
              </div>
            </ion-col>
            <ion-col size="6" *ngIf="!isSubscribed">
              <div style="padding: 16px">
                <ion-button
                  class="btn-large"
                  size="block"
                  (click)="openCheckout()"
                  *ngIf="upgradePriceId && upgradeProductId"
                >
                  Continue to Checkout
                  <ion-icon
                    name="arrow-forward"
                    class="icon-padded-left"
                  ></ion-icon>
                </ion-button>
                <ion-button
                  class="btn-large"
                  href="mailto:sales@unthread.io"
                  target="_blank"
                  *ngIf="!upgradePriceId || !upgradeProductId"
                >
                  Contact us to Upgrade
                  <ion-icon
                    name="arrow-forward"
                    class="icon-padded-left"
                  ></ion-icon>
                </ion-button>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
        <ion-button
          *ngIf="isFailed"
          fill="clear"
          class="btn-large"
          size="block"
          (click)="getInitialData()"
        >
          Something went wrong. Try again.
        </ion-button>
      </div>
      <div style="text-align: center; padding: 16px">
        <ion-button
          href="mailto:sales@unthread.io"
          fill="clear"
          color="dark"
          target="_blank"
        >
          <ion-icon name="mail" class="padded-icon"></ion-icon>
          Email sales
        </ion-button>
        <ion-button
          fill="clear"
          color="dark"
          target="_blank"
          href="https://calendly.com/tom-unthread/30min"
        >
          <ion-icon name="calendar" class="padded-icon"></ion-icon>
          Book a meeting
        </ion-button>
      </div>
    </div>
  }
</ion-content>
